import React, { useEffect, useState } from "react";
import axios from "axios";

// Renamed component to start with capital A
const AuthenticatedImage = ({ fileUrl }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  // Construct the full download URL using the fileUrl provided
  const downloadUrl = fileUrl;

  useEffect(() => {
    let currentBlobUrl = null; // Track the URL created in this effect run

    // If there is no file URL, we can't do anything
    if (!fileUrl) {
      setIsLoading(false);
      return;
    }

    // 1. Fetch the image data securely with credentials
    const fetchImage = async () => {
      setIsLoading(true);
      setImageSrc(null); // Clear previous image source

      try {
        const response = await axios.get(downloadUrl, {
          responseType: 'blob', // Crucial: get the data as binary blob
          withCredentials: true, // Crucial: forces sending of session/cookies
        });

        // 2. Create a local URL for the browser to display
        const blobUrl = URL.createObjectURL(response.data);
        currentBlobUrl = blobUrl; // Save for cleanup
        setImageSrc(blobUrl);

      } catch (error) {
        // Log the full error response to help debug 401/CORS issues
        console.error("❌ Failed to load authenticated image:", error.response || error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImage();

    // 3. Cleanup: Revoke the temporary blob URL when the component unmounts 
    // or before the effect runs again. We use the locally tracked URL.
    return () => {
      if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
      }
    };
  }, [downloadUrl, fileUrl]); 

  // We should also handle case where imageSrc is suddenly revoked by the state cleanup
  // To prevent the image from disappearing if the component re-renders quickly, 
  // we check if we are loading or if we have an image source.
  return (
    <a href={downloadUrl} target="_blank" rel="noreferrer">
      {/* The loader is a simple text div, so it cannot display a blob URL unless a variable 
          was accidentally passed here. */}
      {isLoading && <div className="text-muted small">Loading image...</div>}
      
      {imageSrc && (
        <img
          src={imageSrc} // Use the local blob URL here
          style={{
            width: "150px",
            height: "auto",
            borderRadius: "5px",
            marginTop: "5px",
          }}
          alt="attachment"
        />
      )}
      {!isLoading && !imageSrc && <div className="text-danger small">Failed to load</div>}
    </a>
  );
};

export default AuthenticatedImage;